<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M28 5H7a2 2 0 00-2 2v21a2 2 0 002 2h21a2 2 0 002-2V7a2 2 0 00-2-2zm-1 22H8V8h19zM57 5H36a2 2 0 00-2 2v21a2 2 0 002 2h21a2 2 0 002-2V7a2 2 0 00-2-2zm-1 22H37V8h19zM28 34H7a2 2 0 00-2 2v21a2 2 0 002 2h21a2 2 0 002-2V36a2 2 0 00-2-2zm-1 22H8V37h19zM57 34H36a2 2 0 00-2 2v21a2 2 0 002 2h21a2 2 0 002-2V36a2 2 0 00-2-2zm-1 22H37V37h19z"/></svg>